import { formatDate } from '../utils/formatter';
import { List, ListItem, Loading } from '@op/opds.opux';
import message from '../messages/Message';
import { useLocation, useNavigate } from "react-router-dom";
import '../App.css';
import { SubCategory } from '../utils/routes';
import { usePriceListContent } from '../context/PriceListContext';
import { useEffect } from 'react';
import ErrorView from './ErrorView';

const CurrentPrices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { response, fetchDataPricelist } = usePriceListContent();

  useEffect(() => {
    if (location.state?.scrollToElement) {
      const element = document.querySelector('h2.header');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  if (!response) {
    return <div><Loading /></div>;
  }

  const { effectiveDate, categories } = response;
  const formattedDate = formatDate(effectiveDate);

    if (formattedDate.includes('NaN')) {
        return <ErrorView />;
 }

   const getPricelistCall = async (pricelistId) => {
      const data = await fetchDataPricelist(pricelistId);
        const productGroupContent = [];
        data.productGroups.forEach((productGroup) => {
          productGroup.productGroupContent.forEach((product) => {
            product.productGroupName = productGroup.productGroupName;
            productGroupContent.push(product);
          });
        });
        navigate(SubCategory, { state: { productGroupContent, data } }); // navigate to the SubCategory route with the productGroupContent data as state
    };

 return (
     <div className="runko">
       <p className="opux-v6__opds">{message('catalog_since').replace('effectiveDate', formattedDate)}</p>
       {categories && categories.map((category, categoryIndex) => (
         <div key={categoryIndex}>
           <h3 className="subHeader">{category.categoryName}</h3>
           <List size="small" border="none" style={{ margin: 0 }}>
             {category.categoryContent.map((subcategory, subIndex) => (
               <ListItem
                 key={subIndex}
                 onClick={() => getPricelistCall(subcategory.pricelistId)}
                 onKeyDown={(event) => {
                   if (event.key === 'Enter') {
                     getPricelistCall(subcategory.pricelistId);
                   }
                 }}
                 tabIndex={0} // Make the ListItem focusable
               >
                 {subcategory.pricelistName}
               </ListItem>
             ))}
           </List>
         </div>
       ))}
     </div>
   );
 };

export default CurrentPrices;